import React from 'react';
import moment from 'moment';
import { t } from 'i18next';
import { ENGINE_VERSION_1_0 } from '@/store/Engine/constants';
import { EngineTab } from '@/constants';
import DraftActions from './DraftActions';
import VersionAlert from '../../VersionHistory/VersionAlert';

interface CentrifugalDraftContainerProps {
  engineVersion: string;
  draftPublishedDate?: string;
  activeCentrifugalTab: EngineTab;
  setIsSaveDisabled: (disabled: boolean) => void;
  isSaveDisabled: boolean;
  setActiveTab: (tab: string) => void;
  setActiveCentrifugalTab: (tab: EngineTab) => void;
}

const CentrifugalDraftContainer: React.FC<CentrifugalDraftContainerProps> = ({
  engineVersion,
  draftPublishedDate,
  activeCentrifugalTab,
  setIsSaveDisabled,
  isSaveDisabled,
  setActiveTab,
  setActiveCentrifugalTab,
}) => {
  return (
    <div
      className="draft-container"
      style={{ display: 'flex', justifyContent: engineVersion === ENGINE_VERSION_1_0 ? 'space-between' : 'flex-end' }}
    >
      <VersionAlert engineVersion={engineVersion} />
      <div className="actions-container">
        {draftPublishedDate && (
          <div className="draft-published-text">
            {t('draftPublishedOn')}
            {moment(draftPublishedDate).format('MMM D, YYYY')}
          </div>
        )}
        {activeCentrifugalTab !== 'general' && (
          <DraftActions
            setIsSaveDisabled={setIsSaveDisabled}
            isSaveDisabled={isSaveDisabled}
            setActiveTab={setActiveTab}
            setActiveCentrifugalTab={setActiveCentrifugalTab}
          />
        )}
      </div>
    </div>
  );
};

export default CentrifugalDraftContainer;
